import { render, staticRenderFns } from "./EditorInput.vue?vue&type=template&id=86534e5e&lang=pug"
import script from "./EditorInput.vue?vue&type=script&lang=ts"
export * from "./EditorInput.vue?vue&type=script&lang=ts"
import style0 from "./EditorInput.vue?vue&type=style&index=0&id=86534e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports